import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {UIGameActionButtonView} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonView'
import {UIGameActionsController} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionsController'
import {UIGameActionButtonViewTrade} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonViewTrade'
import {UIGameActionButtonViewTurn} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonViewTurn'
import {GameStateEnums} from '../../../../../shared/GameEnums'

import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIMGameManager} from '../UIMGameManager'
import {MechanicCityState, MechanicRoadState, MechanicSettlementState} from '@colonist/game-states'

export class UIMGameActionsController extends UIGameActionsController {
    constructor(uiGameManager: UIMGameManager, settlementState: MechanicSettlementState | undefined, cityState: MechanicCityState | undefined, roadState: MechanicRoadState | undefined) {
        super(uiGameManager, settlementState, cityState, roadState)
        this.onTurnUpdate()
        uiGameManager.animationController.registerForFeedMechanics(this.container)
    }

    protected addDefaultButtons() {
        this.buttonViews.push(new UIGameActionButtonViewTrade(this.uiGameManager, this.container))
        this.buttonViews.push(new UIGameActionButtonViewTurn(this.uiGameManager, this.container))
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        super.onEvent(data, eventType)
        switch(eventType) {
            case UIGameEventEnums.GameStateUpdated: this.onTurnUpdate(); break
            default: break
        }
    }

    protected getContainer(): SectionBgView {
        const canvas = this.uiGameManager.canvasController
        const w = canvas.itemSize
        const h = canvas.itemSize
        const x = canvas.appW / 2
        const y = canvas.appH - canvas.bottomViewHeight - h

        const container = new SectionBgView(x, y, w, h, canvas.app.stage, true)

        return container
    }

    protected onCanvasResize() {
        const canvas = this.uiGameManager.canvasController
        const h = canvas.itemSize
        const x = canvas.appW / 2
        const y = canvas.appH - canvas.bottomViewHeight - h
        this.container.position.set(x, y)
        this.container.initialPosition.x = x
        this.container.initialPosition.y = y
        this.buildButtonController()
    }

    protected repositionButton(button: UIGameActionButtonView, row: number, column: number) {
        const canvas = this.uiGameManager.canvasController
        const padding = canvas.itemSize / 8
        button.x = column * (canvas.itemSize + padding) - this.buttonViews.length * padding
        button.y = -padding + (row * canvas.itemSize)
        button.width = canvas.itemSize
        button.height = canvas.itemSize
        button.repositionedButton()
    }

    private onTurnUpdate() {
        const shouldShowDice = this.uiGameManager.gameController.isMyTurn ? true : false
        this.container.visible = shouldShowDice
    }
}
